import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Sprite = Phaser.GameObjects.Sprite;
import SpriteUtils from "@/utils/sprite-utils";

export class HolidayPanel extends VerticalStandardPanel {

    private lighting!: Sprite;

    constructor(scene: Scene, canvas: HTMLCanvasElement, titleText: string) {
        super(scene, canvas, titleText);
        this.background.setAlpha(0.01);
    }

    protected preInit(): void {
        this.lighting = SpriteUtils.addSprite(this.scene, 0, 0, Keys.OFFER_LIGHT_BACK, undefined, 4.6).setAlpha(0);
        this.add(this.lighting);

        this.scene!.tweens.add({
            targets: this.lighting,
            alpha: 1,
            duration: 500
        });

        this.scene!.tweens.add({
            targets: this.lighting,
            angle: 360,
            duration: 90000,
            loop: -1,
        });
    }

    protected preClose(): void {
        this.lighting.setVisible(false);
    }
}
